import { captchaProvider } from '@/helpers/Environment'

export function resetReCaptcha() {
  if (captchaProvider === 'recaptcha') {
    // reset() will cause captcha expiry to no longer trigger so have to also remove the token.
    window.grecaptcha?.reset()
    window.tixRecaptchaToken = undefined
  }
}
